import { useSWRConfig } from "swr";
import { useApi } from "../../../swr/useApi";
import { adminLoyaltyService, loyaltyService } from "../../api_client";
import type {
  CreateLoyaltyPromotionDto,
  LoyaltyPromotionDto,
  UpdateLoyaltyPromotionDto,
} from "../../../api";

const ADMIN_KEY = "admin-loyalty-promotions";
const ACTIVE_KEY = "active-loyalty-promotions";

/** Admin: all loyalty promotions (any status). */
export function useLoyaltyPromotions() {
  return useApi<LoyaltyPromotionDto[]>(ADMIN_KEY, () =>
    adminLoyaltyService.adminGetLoyaltyPromotions(),
  );
}

/** Buyer-facing: promotions active right now (enabled + in window). */
export function useActiveLoyaltyPromotions() {
  return useApi<LoyaltyPromotionDto[]>(ACTIVE_KEY, () =>
    loyaltyService.getActiveLoyaltyPromotions(),
  );
}

/** Create/update/delete promotions, revalidating both the admin and active lists. */
export function useLoyaltyPromotionMutations() {
  const { mutate } = useSWRConfig();

  const revalidate = async () => {
    await Promise.all([mutate(ADMIN_KEY), mutate(ACTIVE_KEY)]);
  };

  return {
    create: async (dto: CreateLoyaltyPromotionDto) => {
      const res = await adminLoyaltyService.adminCreateLoyaltyPromotion(dto);
      await revalidate();
      return res.data;
    },
    update: async (id: string, dto: UpdateLoyaltyPromotionDto) => {
      const res = await adminLoyaltyService.adminUpdateLoyaltyPromotion(id, dto);
      await revalidate();
      return res.data;
    },
    remove: async (id: string) => {
      await adminLoyaltyService.adminDeleteLoyaltyPromotion(id);
      await revalidate();
    },
  };
}
